import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Paragraph } from '@sovryn/ui';
import { SocialLinks } from 'components/SocialLinks/SocialLinks';
import { useMemo } from 'react';
export const Footer = () => {
    const year = useMemo(() => new Date().getFullYear(), []);
    return (_jsxs("footer", { className: "py-4 bg-transparent w-full flex justify-between items-center max-w-5xl mx-auto p-4 mt-4", children: [_jsx(Paragraph, { className: "text-white text-opacity-30 whitespace-break-spaces text-tiny font-medium", children: `© ${year} BitcoinOS\nAll Rights Reserved` }), _jsx(SocialLinks, {})] }));
};
